"use strict";

exports.__esModule = true;
exports.default = void 0;

require("./language.less");

var _react = _interopRequireDefault(require("react"));

var _tools = _interopRequireDefault(require("../libs/tools"));

var _component = _interopRequireDefault(require("../core/component"));

var _enhance = _interopRequireDefault(require("../core/enhance"));

var _http = _interopRequireDefault(require("./http"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _url;

global.lang = _tools.default.cache('Language') || {};
/**
 * 语言包
 */

var Language = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Language, _Component);

  Language.url = function url(val) {
    _url = val;
  };

  function Language(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {};

    if (props.language) {
      $.extend(global.lang, props.language);
    }

    return _this;
  }

  Language.register = function register(data) {
    $.extend(global.lang, data);
  }
  /**
   * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
   */
  ;

  var _proto = Language.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (_url !== false) {
      // 兼容老版本
      var u = _url || window.SERVER_URL + "/admin/system/language/";
      u && this.REF_http.send(u).success(function (data) {
        _tools.default.cache(_tools.default.md5(u) + '.LANGUAGE', data, 0);

        Language.register(data);

        _this2._emit('Language');
      });
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    return /*#__PURE__*/_react.default.createElement(_http.default, {
      ref: function ref(_ref) {
        return _this3.REF_http = _ref;
      }
    });
  };

  return Language;
}(_component.default);

Language.propTypes = {
  language: _propTypes.default.object
};
Language.displayName = "Language";
var _default = Language;
exports.default = _default;
module.exports = exports.default;